<!-- DESKTOP LAYOUT -->
<div class="page-content bg-col-51">

    <div class="p-t-17 p-b-20 p-t-10-s">
        <div class="wrap">
            <ng-container *ifSize="'XL'">
                <!-- heading ro -->
                <account-greeting class="block p-b-6 b-b m-b-15"></account-greeting>
                <!-- left side nav -->
                <div class="c-3 m-b-0">
                    <account-navigation></account-navigation>
                </div>

            </ng-container>

            <!-- main content -->
            <div class="m-b-0 m-r-0 c-12-s c-12-m"
                 [ngClass]="'c-' + (forceContentCols || 7)">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <icms-outlet-block class="block"
                      variant="account-page"
                      name="Account pages components">
    </icms-outlet-block>
</div>